import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import parser from 'html-react-parser';

const ImprintContent = () => {
  const { t } = useLanguage();

  return (
    <div className="st-imprint-content">
      <h1 className="st-imprint-title">{t('imprint.content.title')}</h1>
      <p className="st-imprint-updated">
        <strong>{t('imprint.lastUpdatedLabel')}:</strong> {t('imprint.lastUpdated')}
      </p>

      <section className="st-imprint-section">
        <h2 className="st-imprint-section-title">{t('imprint.content.ddg')}</h2>
        <div className="st-imprint-section-content">
          {parser(t('imprint.content.description'))}
        </div>
      </section>

      <section className="st-imprint-section">
        <h2 className="st-imprint-section-title">{t('imprint.content.provider.title')}</h2>
        <div className="st-imprint-section-content">
          <p><strong>{t('imprint.content.provider.name')}</strong></p>
        </div>
      </section>

      <section className="st-imprint-section">
        <h2 className="st-imprint-section-title">{t('imprint.content.address.title')}</h2>
        <div className="st-imprint-section-content">
          <p>
          {t('imprint.content.address.name')}<br/>
            {t('imprint.content.address.street')}<br/>
            {t('imprint.content.address.city')}<br/>
            {t('imprint.content.address.country')}
          </p>
        </div>
      </section>

      <section className="st-imprint-section">
        <h2 className="st-imprint-section-title">{t('imprint.content.contact.title')}</h2>
        <div className="st-imprint-section-content">
          <p>{t('imprint.content.contact.email')}<br/>
          {t('imprint.content.contact.phone')}</p>
        </div>
      </section>

      <section className="st-imprint-section">
        <h2 className="st-imprint-section-title">{t('imprint.content.contentResponsible.title')}</h2>
        <div className="st-imprint-section-content">
          <p><strong>{t('imprint.content.contentResponsible.name')}</strong><br/>
          {t('imprint.content.contentResponsible.note')}</p>
        </div>
      </section>

      <section className="st-imprint-section">
        <h2 className="st-imprint-section-title">{t('imprint.content.coFounders.title')}</h2>
        <div className="st-imprint-section-content">
          <ul className="st-imprint-team-list">
            {(t('imprint.content.coFounders.members') || []).map((member, index) => (
              <li key={index}>
                <strong>{member.name}</strong> - {member.role}
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="st-imprint-section">
        <h2 className="st-imprint-section-title">{t('imprint.content.partner.title')}</h2>
        <div className="st-imprint-section-content">
          <p><strong>{t('imprint.content.partner.organizationName')}</strong></p>
          <p>
            {t('imprint.content.partner.street')}<br/>
            {t('imprint.content.partner.city')}<br/>
            {t('imprint.content.partner.country')}
          </p>
        </div>
      </section>

      <section className="st-imprint-section">
        <h2 className="st-imprint-section-title">{t('imprint.content.projectStatus.title')}</h2>
        <div className="st-imprint-section-content">
          {parser(t('imprint.content.projectStatus.content'))}
        </div>
      </section>

      <section className="st-imprint-section">
        <h2 className="st-imprint-section-title">{t('imprint.content.liabilityContent.title')}</h2>
        <div className="st-imprint-section-content">
          {parser(t('imprint.content.liabilityContent.content'))}
        </div>
      </section>

      <section className="st-imprint-section">
        <h2 className="st-imprint-section-title">{t('imprint.content.liabilityLinks.title')}</h2>
        <div className="st-imprint-section-content">
          {parser(t('imprint.content.liabilityLinks.content'))}
        </div>
      </section>

      <section className="st-imprint-section">
        <h2 className="st-imprint-section-title">{t('imprint.content.copyright.title')}</h2>
        <div className="st-imprint-section-content">
          {parser(t('imprint.content.copyright.content'))}
        </div>
      </section>

      <section className="st-imprint-section">
        <h2 className="st-imprint-section-title">{t('imprint.content.disputeResolution.title')}</h2>
        <div className="st-imprint-section-content">
          {parser(t('imprint.content.disputeResolution.content'))}
        </div>
      </section>
    </div>
  );
};

export default ImprintContent;
